import admin from './admin.json';
import auth from './auth.json';
import content from './content.json';
import crud from './crud.json';
import entities from './entities.json';
import entityFields from './entityFields';
import headerLinks from './headerLinks.json';
import mailLayout from './mailLayout.json';
import menu from './menu.json';
import menuItems from './menuItems.json';
import messages from './messages.json';
import notFound from './notFound.json';
import oauth from './oauth.json';
import strings from './strings.json';
import tenants from './tenants.json';
import users from './users.json';

export default {
  admin,
  auth,
  content,
  crud,
  entities,
  entityFields,
  headerLinks,
  mailLayout,
  menu,
  menuItems,
  messages,
  notFound,
  oauth,
  strings,
  tenants,
  users,
};
